var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.htmlTag ? _vm.htmlTag : 'div',{tag:"component",class:[
        _vm.type === 'block' ? 'skeleton-block' : '',
        _vm.type === 'text' ? 'skeleton-text' : '',
        _vm.effect && _vm.effect !== '' ? ("skeleton-effect-" + _vm.effect) : '' ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }